var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.03 18.31H9.2c-.99 0-1.8.81-1.8 1.8v7.56c0 1 .81 1.8 1.8 1.8h1.83zM24.5 21.59l-1.66 5.98a2.58 2.58 0 0 1-2.49 1.9h-7.82V18.31l3.3-4.67a1.873 1.873 0 0 1 3.33 1.59l-.87 3.08h3.72c1.71 0 2.95 1.63 2.49 3.28zM6.082 6.799l.751 1.521a.486.486 0 0 0 .366.266l1.679.244a.486.486 0 0 1 .269.828l-1.215 1.184a.487.487 0 0 0-.14.43l.287 1.672a.486.486 0 0 1-.705.512l-1.502-.789a.488.488 0 0 0-.452 0l-1.502.789a.486.486 0 0 1-.705-.512l.287-1.672a.485.485 0 0 0-.14-.43L2.147 9.658a.486.486 0 0 1 .269-.828l1.679-.244a.488.488 0 0 0 .366-.266l.751-1.521a.485.485 0 0 1 .87 0zM16.435 2.799l.751 1.521a.486.486 0 0 0 .366.266l1.679.244a.486.486 0 0 1 .269.828l-1.215 1.184a.487.487 0 0 0-.14.43l.287 1.672a.486.486 0 0 1-.705.512l-1.502-.789a.488.488 0 0 0-.452 0l-1.502.789a.486.486 0 0 1-.705-.512l.287-1.672a.485.485 0 0 0-.14-.43L12.5 5.658a.486.486 0 0 1 .269-.828l1.679-.244a.486.486 0 0 0 .366-.266l.751-1.521a.485.485 0 0 1 .87 0zM26.788 6.799l.751 1.521a.486.486 0 0 0 .366.266l1.679.244a.486.486 0 0 1 .269.828l-1.215 1.184a.487.487 0 0 0-.14.43l.287 1.672a.486.486 0 0 1-.705.512l-1.502-.789a.488.488 0 0 0-.452 0l-1.502.789a.486.486 0 0 1-.705-.512l.287-1.672a.485.485 0 0 0-.14-.43l-1.215-1.184a.486.486 0 0 1 .269-.828l1.679-.244a.486.486 0 0 0 .366-.266l.751-1.521a.486.486 0 0 1 .872 0z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.5c050f404b253f104e18a1b123848b18.svg";
export { ForwardRef as ReactComponent };